import {Injectable} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {validateMatch, validatePassword} from "../common/validations";

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  private readonly CHARACTERS: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijkl_?.-$&mnopqrstuvwxyz0123456789';


  public generateAndSetPassword(userForm: FormGroup): void {
    let result: string = '';
    const charactersLength: number = this.CHARACTERS.length;
    for (let i: number = 0; i < 16; i++) {
      result += this.CHARACTERS.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    userForm.get('confirmPassword').setValue(result);
    userForm.get('password').setValue(result);
    this.newPasswordCheck(userForm);
  }

  public newPasswordCheck(userForm: FormGroup): void {
    const value = userForm.get('password').value;
    const confirmValue = userForm.get('confirmPassword').value;

    if (value.length > 0 || confirmValue.length > 0) {
      userForm.get('confirmPassword').setValidators([validatePassword(), validateMatch(value)]);
      userForm.get('password').setValidators([validatePassword(), validateMatch(confirmValue)]);
    } else {
      userForm.get('confirmPassword').setValidators([]);
      userForm.get('password').setValidators([]);
    }
    userForm.get('password').updateValueAndValidity();
    userForm.get('confirmPassword').updateValueAndValidity();
  }

}
